export default "__VITE_ASSET__e75e4f46__"